import moment from 'moment';
import Pikaday from '../../vendor/pikaday';

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

/**
 * <date-picker v-model="date" id="inputID" name="inputName">
 * Used to pull in Pikaday which wouldn't work properly while Vue was doing its thing
 */
Vue.component('date-picker', {
  template: `
    <input type="text"
      v-bind:id="id"
      v-bind:name="name"
      placeholder="Bill Due Date"
      readonly="true"
      class="w-100 datepicker"
      data-disable-past="true"
      aria-labelledby="payment-date-label enrollments"
      v-model="internalValue"
      v-bind:data-date-picker-container="id + 'Container'">
  `,

  /**
   * Props array
   * @type {string} props.id allows us to have multiple on the page if necessary
   * @type {string} props.name for the submission if done server-side
   * @type {boolean} props.showpast is for setting the minimum date
   * @type {string} props.initialDate is for setting the initial date
   */
  props: {
    id: String,
    name: String,
    showPast: Boolean,
    initialDate: Object,
    events: {
      type: Array,
      default() {
        return [];
      },
    },
    maxDate: {
      type: Object,
      default() {
        return null;
      },
    },
    validDates: {
      type: Object,
      default() {
        return null;
      },
    },
    disableWeekends: {
      type: Boolean,
      default: false,
    },
    displayDate: String,
  },

  created() {
    this.internalValue = this.date;

    // when the component is created, check if a date was already selected
    // this will happen when the component is re-initialized on "previousStep()"
    // and the user set the date the first time
    if (this.displayDate && this.displayDate !== 'Current Due Date') {
      this.alreadySelectedDate = this.displayDate;
    }
  },

  /**
   * Data function
   */
  data() {
    return {
      internalValue: '',
      alreadySelectedDate: '',
    }
  },

  mounted() {
    Vue.nextTick(() => {
      const self = this;
      /**
       * Set up pikaday to do its thing on the input
       */
      const containerName = this.$el.getAttribute('data-date-picker-container');
      const dateBoxContainer = document.getElementById(containerName);
      const picker = new Pikaday({
        field: this.$el,
        format: 'MMM D, YYYY',
        container: dateBoxContainer,
        disableWeekends: self.disableWeekends,
        maxDate: self.maxDate,
        events: self.events,
        disableDayFn: (date) => {
          // validDates property is set using v-bind in the HTML
          const validDateArray = self.validDates;
          // if valid dates are set specifically, and if the date displayed in the calendar isn't included in that array of valid dates, return true (disable the date)
          // use moment to format the date as needed depending on what the original format is
          if (validDateArray !== null && validDateArray.indexOf(new moment(date).format('MMM D, YYYY')) === -1) { // eslint-disable-line new-cap
            return true;
          }
          // else return false to show the dates by default
          return false;
        },
        toString(date) {
          const day = date.getDate();
          // use the months array for english version of month
          const month = months[date.getMonth()];
          const year = date.getFullYear();
          self.$el.dataset.date = day;
          // Pikaday expects us to return a string
          // so set the data value and then return it
          self.internalValue = `${month} ${day}, ${year}`;
          return self.internalValue;
        },
      });

      if (self.showPast === "false") {
        picker.setMinDate(new Date());
      }

      if (self.initialDate) {
        picker.setDate(self.initialDate);
      }

      // if there was already a date selected, reset this date
      if (this.alreadySelectedDate) {
        picker.setDate(this.alreadySelectedDate);
      }
    });
  },

  watch: {
    /**
     * Required to send data back up to the parent Vue app
     */
    internalValue() {
      this.$emit('input', this.internalValue);
    },
  },

});



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/portal/vue/components/date-picker.js